import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { PackageType } from 'shared/packages/domain/packageType';
import { usePackageTypeStore } from 'shared/packages/stores/packageTypeStore';

export interface CreatePackageType {
  name: string;
  pieces: number;
  layers: number | null;
  piecesPerLayer: number | null;
  spacerHeight: number | null;
  packagingIds: string[];
}

export interface CreatePackageTypeResponse {
  ok: true;
  packageType: PackageType;
}

export function useCreatePackageType() {
  const store = usePackageTypeStore();

  return useCreateEntityApi<CreatePackageType, CreatePackageTypeResponse>({
    url: 'packageType',
    translate: (t) => t.packageTypes.actions.create,
    async processOk(response) {
      const json = await response.json() as PackageType;
      store.add(json);
      return {
        ok: true,
        packageType: json,
      };
    },
  });
}
